import { LogoMark } from "../components/Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "problem", label: "The Problem" },
  { id: "solution", label: "Solution" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "contact", label: "Get in Touch" },
];

const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 py-14">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-10 px-4 sm:px-6 lg:flex-row lg:px-8">
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center rounded-xl bg-white px-3 py-1.5">
          <LogoMark size={26} />
        </span>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
          Shelf-life advisory · Australia
        </p>
      </div>
      <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
        {LINKS.map((l) => (
          <a
            key={l.id}
            href={`#${l.id}`}
            onClick={(e) => { e.preventDefault(); scrollToId(l.id); }}
            data-testid={`footer-link-${l.id}`}
            className="text-sm text-slate-500 transition-colors duration-300 hover:text-green-300"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <p className="text-sm text-slate-600">© 2026 Shelf Sense. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
